import { Backdrop, CircularProgress, Grid2, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
const live_events_service = require('../../helpers/live_events_service')
const Home = () => {
  const [evento, setEvento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [contador] = useState(0)
  useEffect(() => {
    live_events_service.getData('/evento/view-by-hash/' + process.env.REACT_APP_EVT).then((response) => {
      setEvento(response.data.response_database.result[0])
      setLoading(false)
    }).catch((error) => {
      console.log(error)
    })
  }, [contador])
  return (
    <Stack spacing={3}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack spacing={3} textAlign="justify" p={5}>
        <Typography variant="h4" textAlign="center">
          Objetivo del Congreso COREFIS
        </Typography>
        <Typography variant="p" textAlign="center">
          Promover el conocimiento y la implementación de prácticas financieras sostenibles, impulsando estrategias e iniciativas que contribuyan a la transformación económica, ambiental y social en la región, con un enfoque en la innovación y la responsabilidad corporativa.
        </Typography>
      </Stack>
      <Grid2 container justifyContent="center" p={3}>
        <Grid2 size={{ xs: 12, md: 12, lg: 6 }} style={{ textAlign: "center" }}>
          <video playsInline autoPlay controls style={{ width: "75%" }}>
            <source
              // src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/8fa94c32-0ac9-4c02-9bea-9efac1bd5343.mp4"
              src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/a5e9f2fe-607e-40e7-a82b-81ff4067d2c6.mp4'
              type="video/mp4"
            />
          </video>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
          <Stack spacing={3}>
            <Typography variant="h5" textAlign="center">
              ¿A quién va dirigido?
            </Typography>
            <Typography variant="p" style={{ textAlign: "justify" }}>
              <ul>
                <li><strong>Altos ejecutivos y directivos</strong>
                  <ul>
                    <li>Presidentes y vicepresidentes de bancos</li>
                    <li>CEOs y CFOs de entidades financieras</li>
                    <li>Miembros de juntas directivas</li>
                  </ul>
                </li>
                <li><strong>Gerentes y líderes de áreas clave</strong>
                  <ul>
                    <li>Gerentes de sostenibilidad y responsabilidad social corporativa</li>
                    <li>Gerentes de riesgo financiero y cumplimiento regulatorio</li>
                    <li>Gerentes de inversión y fondos sostenibles</li>
                    <li>Gerentes de innovación y transformación digital</li>
                  </ul>
                </li>
                <li><strong>Profesionales de banca y finanzas</strong>
                  <ul>
                    <li>Analistas financieros y de riesgos</li>
                    <li>Especialistas en financiamiento verde y bonos sostenibles</li>
                    <li>Oficiales de crédito y banca corporativa</li>
                    <li>Consultores en finanzas sostenibles</li>
                  </ul>
                </li>
                <li><strong>Reguladores y supervisores</strong>
                  <ul>
                    <li>Representantes de bancos centrales</li>
                    <li>Funcionarios de superintendencias bancarias y financieras</li>
                    <li>Especialistas en normativas de finanzas sostenibles</li>
                  </ul>
                </li>
                <li><strong>Inversionistas y académicos</strong>
                  <ul>
                    <li>Gestores de fondos de inversión sostenible</li>
                    <li>Investigadores y profesores en temas de finanzas y sostenibilidad</li>
                    <li>Organismos multilaterales y ONGs relacionadas con el sector financiero</li>
                  </ul>
                </li>
                <li><strong>Empresarios y tomadores de decisiones</strong>
                  <ul>
                    <li>Representantes de grandes corporaciones con estrategias ESG</li>
                    <li>Startups y fintech enfocadas en impacto ambiental y social</li>
                    <li>Empresas del sector asegurador y de pensiones</li>
                  </ul>
                </li>
              </ul>

            </Typography>
          </Stack>
        </Grid2>
      </Grid2>
      <Stack spacing={3} style={{ textAlign: 'center' }}>

      </Stack>
    </Stack>
  );
};

export default Home;

/*

LinkedInIcon
FacebookIcon
XIcon
InstagramIcon
YouTubeIcon
*/

///https://escuela-bancaria.s3.us-east-2.amazonaws.com/logo+FELABAN+blanco.png

//https://escuela-bancaria.s3.us-east-2.amazonaws.com/logo+ABG+blanco.png
